import { InjectionToken } from '@angular/core';
import { TradingCommandPort } from '../ports/trading-command.port';

export const TRADING_COMMAND_TOKEN = new InjectionToken<TradingCommandPort>('TradingCommandPort');
